import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=53c21f71&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=ts&"
export * from "./Accessibility.vue?vue&type=script&lang=ts&"
import style0 from "./Accessibility.vue?vue&type=style&index=0&id=53c21f71&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c21f71",
  null
  
)

export default component.exports